import { render } from "./SelectPrincipal.vue?vue&type=template&id=76000544&scoped=true"
import script from "./SelectPrincipal.vue?vue&type=script&lang=js"
export * from "./SelectPrincipal.vue?vue&type=script&lang=js"

import "./SelectPrincipal.vue?vue&type=style&index=0&id=76000544&lang=scss&scoped=true"
import "./SelectPrincipal.vue?vue&type=style&index=1&id=76000544&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76000544"]])

export default __exports__